import React, { useState } from 'react'
import ReactTooltip from 'react-tooltip'
import { ReactComponent as Info } from '../../assets/svg/InfoIcon.svg'

const InfoButton = ({ text, color = '#5E639B', tooltipId = `${Math.random()}` }) => {
    return (
        <div className="flex items-center">
            <div data-tip={text} data-for={tooltipId} style={{ display: 'inline-block' }} className="hover:cursor-pointer">
                <Info style={{ color }} />
            </div>
            <ReactTooltip id={tooltipId} arrowColor="#5E639B" effect="solid" backgroundColor="#5E639B" className="wellbeing-tooltip" />
        </div>
    )
}

export default InfoButton
